import PropTypes from "prop-types";
import { connect } from "react-redux";
import React, { Component } from "react";
import { bindActionCreators } from "redux";
import Modal from "../../../../utils/customModal";
import { getSpk } from "../../../../../Redux/reducer/env";
import * as instanceActions from "../../../../../Redux/api";
import { encryptPassword } from "../../../../utils/functions";
import StepControl from "../../register/steps/stepControl";
import {
  loadingHtml,
  errorContainer,
  infoContainer,
} from "../../../../utils/functions";

import UserIcon from "../../../../../../static/images/email-icon.svg";
import CloseIcon from "../../../../../../static/images/close-icon.svg";
import ErrorIcon from "../../../../../../static/images/error-icon.svg";

export class ResetStep4 extends Component {
  constructor(props, context) {
    super(props, context);
    this.state = {
      user: {
        email: "",
      },
      modal: {
        show: false,
        content: null,
        onClose: undefined,
      },
      errors: {
        email: "",
      },
    };
  }

  handlerChange(event) {
    // Limpiamos los errores
    const { user, errors } = this.state;
    errors[event.target.name] = "";
    user[event.target.name] = event.target.value;

    this.setState({ user, errors });
  }

  closeModal = () => {
    const { modal } = this.state;
    modal.show = false;
    modal.content = null;
    modal.onClose = undefined;
    this.setState({ modal });
  };

  closeButton(element) {
    return this.state.user[element] != "" ? (
      <div
        key={`clear-${element}`}
        className="button-auto input-w-aux__action clear-user"
        onClick={(event) => this.clear(event, element)}
      >
        <img src={CloseIcon} alt={`limpiar`} />
      </div>
    ) : null;
  }

  clear(event, element) {
    event.preventDefault();
    const user = this.state.user;
    user[element] = "";

    this.setState({ user });
  }

  nextStep = () => {
    this.props.submitStep(true);
  };

  Step5 = () => {
    var buttons = {
      SelBtn: {
        text: "Aceptar",
        action: this.nextStep,
      },
    };

    var content = infoContainer(
      "Confirmación de usuario",
      `Su contraseña provisional ha sido enviada a su correo registrado`,
      buttons
    );
    this.setState({ modal: { content, show: true } });
  };

  submitForm(e) {
    e.preventDefault();
    const { user, errors } = this.state;

    // validamos campos vacios
    if (user.email != "") {
      errors.email = "";
      this.setState({ errors });
      //si todo va bien vamos al paso 2
      const { user, modal } = this.state;
      const { instance: { instanceAction } } = this.props;

      modal.show = true;
      modal.content = loadingHtml();
      this.setState({ modal });
      return instanceAction(`/password-recovery/check-email`, "put", {
        codUser: encryptPassword(this.props.user.codUser, this.props.spk),
        email: encryptPassword(user.email, this.props.spk),
      })
        .then(() => {
          this.Step5();
        })
        .catch((err) => {
          if (
            err.response !== undefined &&
            Array.isArray(err.response.data.notifications)
          ) {
            const notification = err.response.data.notifications[0];
            modal.content = errorContainer(
              notification.message,
              notification.description,
              { continueBtn: { action: this.closeModal, text: 'Aceptar' } }
            );
          }
          modal.onClose = () => this.closeModal();
          this.setState({ modal });
        });
    } else {
      errors.email = "Debe completar este campo";
      this.setState({ errors });
    }
  }


  inputErrors(id, hasFocus = false) {
    document.getElementById(id).classList.add("input--error");
    if (hasFocus) {
      document.getElementById(id).focus();
    }
  }

  displayError(id) {
    const { errors } = this.state;

    return errors[id] != "" ? (
      <div id="select-2-error" className="error">
        <span className="error__icon">
          <img src={ErrorIcon} alt="Error" />
        </span>
        <div className="error__text">{errors[id]}</div>
      </div>
    ) : null;
  }

  render() {
    const { modal } = this.state;
    return (
      <div id="step-1">
        <div className="user-credentials">
          <h1>Correo electrónico</h1>
          <div className="login-form">
            <form className="login" action="post" onSubmit={(e) => this.submitForm(e)}>
              <div className="input-w-aux">
                <img
                  className="button input-w-aux__icon"
                  src={UserIcon}
                  alt={`Usuario`}
                />
                <input
                  id="email"
                  name="email"
                  type="text"
                  className="input input--text input-w-aux__input input--active"
                  autoComplete="off"
                  placeholder={`Digite su correo electrónico`}
                  value={this.state.user.email}
                  onChange={(event) => this.handlerChange(event)}
                />
                {this.closeButton("email")}
                {this.displayError("email")}
              </div>
              <StepControl
                currentStep={4}
                submitStep={(e) => this.submitForm(e)}
              />
            </form>
          </div>
        </div>
        <Modal
          key={`provider-users`}
          show={modal.show}
          handleClose={modal.onClose}
        >
          {modal.content}
        </Modal>
      </div>
    );
  }
}

ResetStep4.propTypes = {
  user: PropTypes.object,
  submitStep: PropTypes.func.isRequired,
};

export const mapStateToProps = (state) => {
  return {
    spk: getSpk(state),
  };
};

export const mapDispatch = (dispatch) => {
  return {
    instance: bindActionCreators(instanceActions, dispatch),
  };
};

export default connect(
  mapStateToProps,
  mapDispatch
)(ResetStep4);
